import styled from "styled-components";
import {down} from "styled-breakpoints";

export const CartItemStyle = styled.div`
    font-family: Archivo;
    position: relative;

    > div.first {
        display: flex;
        align-items: start;
        margin-right: 10px;

        label {
            width: 20px;
            height: 20px;
            margin-right: 4px;
            margin-top: 2px;

            input {
                position: absolute;
                inset: 0;
                opacity: 0;
                cursor: pointer;
            }
        }
    }

    > div:first-child {
        border: 1px solid #F2F2F2;
        width: 100%;
        padding: 10px;
        border-radius: 8px;

        > .card-img {
            width: 60px;
            height: 60px;
            overflow: hidden;
            border-radius: 8px;

            img {
                width: 100%;
                object-fit: cover;
            }
        }

        > .card-body {
            > .first {
                > .card-title {
                    display: block;
                    max-width: 300px;
                    word-wrap: break-word;
                    overflow-wrap: break-word;
                    white-space: normal;
                    --tw-text-opacity: 1;
                    color: var(--color-text-slight-dark);
                    font-size: 16px;
                    line-height: 100%;
                    font-weight: 500;
                }

                > .card-location {
                    font-size: 13px;
                    letter-spacing: 0;
                }

                > .card-delivery-date {
                    font-size: 11px;
                }

                > .card-text {
                    display: flex;
                    align-items: center;
                    line-height: 100%;
                    text-transform: capitalize;
                    color: #808080;

                    &:first-child {
                        font-weight: 400;
                    }

                    &:last-child {
                        font-weight: 300;
                    }
                }
            }

            > div:last-child {
                font-size: 15px;

                p {
                    leading-trim: none;
                    font-size: inherit;
                    line-height: 100%;
                    color: var(--color-primary);
                    text-transform: capitalize;

                    span {
                        font-family: Saira;
                        font-weight: 500;
                    }

                    small {
                        font-weight: 400;
                        font-size: 12px;
                        line-height: 100%;
                        letter-spacing: 0px;
                        text-transform: none;
                        position: relative;
                    }
                }

            }
        }

        > div div:last-child {
            margin-top: 1rem;
        }

        > .quantity {
            margin-left: auto;
            align-self: end;
            justify-content: right;
            text-align: right;

            > div:first-child {

                > .card-text {
                    font-weight: 400;
                    font-size: 12px;
                    color: #808080;

                    b {
                        font-weight: 600;
                        margin-right: 2px;
                    }
                }

                > .badge {
                    padding: 0;
                    --bs-secondary-rgb: 255, 225, 186;
                    color: rgba(255, 165, 49);
                    padding-inline-end: var(--bs-badge-padding-x);

                    > .badge {
                        --bs-secondary-rgb: 255, 165, 49;
                        margin-inline-end: var(--bs-badge-padding-x);

                    }
                }

                .badge {
                    font-size: 9px;
                    font-weight: 500;
                }
            }
        }
    }

    .days-remaining {
        display: inline-flex;
        padding: 0.25rem;
        flex-direction: row;
        -moz-box-align: center;
        align-items: center;
        position: absolute;
        --bs-secondary-rgb: 240,72,72;
        background-color: rgb(240, 72, 72);
        font-weight: 400;
        font-size: 8px;
        right: 0px;
        top: 0px;
        border-radius: 0px 10.63px 0px 13.63px !important;
        z-index: -1;

        > span {
            b {
                font-weight: 600;
            }

            margin-inline-start: 2px;
        }
    }
    ${down("lg")} {
        > div:first-child {
            > .card-body {
                > .first {
                    > .card-title {
                        max-width: 200px;
                    }
                }
            }
            
        }
    }

    ${down("md")} {
        .days-remaining {
            font-size: 6px;
            padding: 5px;
            border-radius: 0px 8px 0px 11.63px !important;
        }

        > div:first-child {
            > .card-body {
                > .first {
                    > .card-title {
                        max-width: 120px;
                        font-size: 12px;
                    }

                    > .card-location {
                        font-size: 8px;
                        font-weight: 300;
                    }
                }
            }
            > div:last-child {
                font-size: 15px;

                p {
                    font-weight: 500 !important;
                    font-size: 10.98px !important;
                    line-height: 100%;
                    letter-spacing: -0.78px !important;
                    text-transform: capitalize;
                    font-family: Saira !important;

                    span {
                        font-weight: 500;
                        all: inherit;
                    }

                    small {
                        font-weight: 400;
                        font-size: inherit;
                        line-height: 100%;
                        letter-spacing: 0px;
                        text-transform: none;
                        position: relative;
                    }
                }

            }
            > div div:last-child {
                margin-top: .5rem;
            }
        }
    }

`
